/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Leveling_ImportInputs */



/**
* | output |
* | --- |
* | "Move over from MEE6 and other bots" |
*
* @param {Pricing_Compare_Leveling_ImportInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_leveling_import = /** @type {((inputs?: Pricing_Compare_Leveling_ImportInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Leveling_ImportInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переезд с MEE6 и других ботов")
	return /** @type {LocalizedString} */ ("Move over from MEE6 and other bots")
});